import { Response } from '@angular/http';
import { HttpClient, HttpParams, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Tuple } from '../../entities/global/model';
import { EquipmentDetails, SystemDetails, Inspection, ChangeMeterUnitModel, UpdateSMUReadingModel, UpdateInspectionForecastingInfoViewModel, FamilyImagesChainFrameImgModel, ComponentWearGraph, ComponentCMU, InspectionWornInfo, InspectionHistroyWornInfo, EquipmentActionHistory, PatchTuple, UpdateForecastDates, ComponentChangeViewModel, EquipmentStatusViewModel, CompartDtoVM, ComponentPositionVM, ChildComponentVM, AddComponentRequest, ApiResponse, EquipmentCompartDtoVM, BushTurnedCalcParams, EquipmentCompartmentTypeModel, EquipmentPercentWornPreferenceDto, SMUValidationCheckRequest, AddNewCompValidationResponseVM, AddComValidationRequest } from './models/manage-equipment.model';
import { catchError } from 'rxjs/operators';
import { RSHMainMPInfo, UnitOfMeasurement } from '../rope-shovel/models/rope-shovel.model';
import { ImplementInspectionAttachmentsVM } from '../GET_NEW_UI/setup-implement/setup-implement.model';
import { ShoeInformationAdd } from '../action/action-models';
@Injectable()
export class ManageEquipmentService {
  private readonly API_BASE = 'api/ManageEquipment/';
  private readonly GET_EQUIPMENT_DETAILS = this.API_BASE + 'GetEquipmentDetails';
  private readonly GET_EQUIPMENT_SYSTEMS = this.API_BASE + 'GetEquipmentSystems';
  private readonly GET_EQUIPMENT_SYSTEMS_ForeCAst = this.API_BASE + 'GetEquipmentSystemsForCast';
  private readonly GET_EQUIPMENT_ACTION_HISTORY = this.API_BASE + 'GetEquipmentActionHistory';//TT-1966
  private readonly GET_EQUIPMENT_ACTION_HISTORY_EDIT = this.API_BASE + 'GetEquipmentActionHistoryToEdit';//TT-1966
  private readonly UPDATE_EQUIPMENT_ACTION_HISTORY = this.API_BASE + 'UpdateEquipmentActionHistory';
  private readonly ROLLBACK_EQUIPMENT_ACTION = this.API_BASE + 'RollbackEquipmentAction';
  private readonly GET_EQUIPMENT_INSPECTIONS = this.API_BASE + 'GetEquipmentInspections';
  private readonly VERIFY_ACCESS = this.API_BASE + 'VerifyUserAccessToEquipment';
  private readonly CHANGE_EQUIPMENT_JOBSITE = this.API_BASE + 'ChangeEquipmentJobsite';
  private readonly CHANGE_EQUIPMENT_SYSTEM_COMPONENT = this.API_BASE + 'ChangeSystemComponent';
  private readonly UPDATE_EQUIPMENT_SMUREADING = this.API_BASE + 'UpdateEquipmentSMU';
  private readonly UPDATE_ForecastDate = this.API_BASE + 'UpdateForecastDates';
  private readonly CHANGE_EQUIPMENT_METER_UNIT = this.API_BASE + 'ChangeMeterUnit';
  private readonly UPDATE_EQUIPMENT_FORECASTING_INFO = this.API_BASE + 'UpdateEquipmentInspectionForecastInfo';
  private readonly GET_ROPESHOVEL_STLYLE = this.API_BASE + 'GetRopeShovelReportStyle';
  private readonly GET_COMPONENT_INSPECTION_LEFT = this.API_BASE + 'GetEquipmentInspectionsForComponetsLEFT';
  private readonly GET_COMPONENT_INSPECTION_RIGHT = this.API_BASE + 'GetEquipmentInspectionsForComponetsRIGHT';
  private readonly GET_COMPONENT_CMU = this.API_BASE + 'GetComponetsCMU';
  private readonly GET_EQUIPMENT_INSPECTION_HISTORY = this.API_BASE + 'GetEquipmentInspectionHistory';
  private readonly GET_EQUIPMENT_INSPECTIONS_LOADMORE = this.API_BASE + 'GetEquipmentInspectionsLoadMore';
  private readonly GET_EQUIPMENT_ALL_TYPE_INSPECTIONS = this.API_BASE + 'GetEquipmentThermoAndGeneralInspections';
  private readonly GET_EQUIPMENT_GENERAL_INSPECTIONS_LOADMORE = this.API_BASE + 'GetEquipmentGeneralInspectionHistory';
  private readonly GET_EQUIPMENT_ACTION_INSPECTIONS_LOADMORE = this.API_BASE + 'GetEquipmentActionInspectionHistory';
  private readonly GET_EQUIPMENT_EOL_INSPECTIONS_LOADMORE = this.API_BASE + 'GetEquipmentEOLInspectionHistory';


  private readonly GET_EQUIPMENT_THERMOGRAPHY_INSPECTIONS_LOADMORE = this.API_BASE + 'GetEquipmentThermInspectionHistory';
  private readonly GET_EQUIPMENT_BOTH_TYPE_INSPECTIONS_LOADMORE = this.API_BASE + 'GetEquipmentBothInspectionHistory';
  private readonly UPDATE_TRACK_FRAME_CONFIG = this.API_BASE + 'UpdateTrackFrameConfiguration';

  private readonly GET_EQUIPMENT_RSH_GENERAL_INSPECTIONS_LOADMORE = this.API_BASE + 'GetEquipmentGeneralInspectionHistoryRSH';
  private readonly GET_COMPONENT_WORN_CALULATE = this.API_BASE + 'GetCalaulateWorn';
  private readonly GET_COMPONENT_MAIN_MEASUREMENT = 'api/RopeShovelInspection/GetMainMeasurementInfo';
  private readonly GET_COMPONENT_WORN_CALULATE_MP = 'api/RopeShovelInspection/CalculateMainMeasurementWorn';
  private readonly GET_PART_MAKE_MODEL = 'api/SetupEquipment/GetPartMakeModel';
  private readonly GET_EQUIPPMENT_STATUS = this.API_BASE + 'GetAllEquipmentStatuses';
  private readonly GET_COMPART_LIST = this.API_BASE + 'GetCompartList';
  private readonly GET_COMPONENT_POSITION = this.API_BASE + 'GetComponentPosition';
  private readonly GET_CHILD_COMPONENT = this.API_BASE + 'GetChildComponents';
  private readonly ADD_NEW_COMPONENT = this.API_BASE + 'AddNewComponent';
  private readonly GET_EQUIPMENT_COMPONENT = this.API_BASE + 'GetEquipmentComponent';
  private readonly UPDATE_BUSH_TURNED = this.API_BASE + 'CalcBushTurned';
private readonly GET_EQUIPMENTBy_SYSTEMS = this.API_BASE + 'GetEquipmentSystemsWithSystemIdSP';
  private readonly GET_MANUAL_INSPECTION_REPORT = this.API_BASE + 'GetManualInspectionReportPdf';
  private readonly GET_EQUIPMENT_SMU_VALIDATION = this.API_BASE + 'SMUValidationCheck';
    private readonly GET_COMP_VALIDATION = this.API_BASE + 'AddNewComponentValidation';

  availableFamilyList: FamilyImagesChainFrameImgModel[];

  constructor(private _http: HttpClient,) { }



  public changeEquipmentJobsite(equipmentId: number, jobsiteId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('jobsiteId', jobsiteId.toString())
    };
    return this._http.get(this.CHANGE_EQUIPMENT_JOBSITE, options).pipe(catchError(this.handleError));
  }

  public GetSMUReadingHistory(equipmentId: number) {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get('api/ManageEquipment/GetSMUUsageHistory', options).pipe(catchError(this.handleError));
  }

  public changeSMUReading(updateModel: UpdateSMUReadingModel): Observable<Tuple> {
    return this._http.post(this.UPDATE_EQUIPMENT_SMUREADING, updateModel).pipe(catchError(this.handleError));
  }


  public changeMeterUnit(changeUnitModel: ChangeMeterUnitModel): Observable<Tuple> {
    return this._http.post(this.CHANGE_EQUIPMENT_METER_UNIT, changeUnitModel).pipe(catchError(this.handleError));
  }

  public updateEquipmentInspectionInfo(updateModel: UpdateInspectionForecastingInfoViewModel): Observable<Tuple> {
    return this._http.post(this.UPDATE_EQUIPMENT_FORECASTING_INFO, updateModel).pipe(catchError(this.handleError));
  }




  public updateTrackFrameConfiguration(systemId: number, selectedvalue: boolean, Type: number, inspectionId: number, side: number, screenId: number): Observable<Inspection[]> {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString()).set('selectedvalue', selectedvalue.toString()).set('Type', Type.toString()).set('inspectionId', inspectionId.toString()).set('Side', side.toString()).set('ScreenId', screenId.toString())
    };
    return this._http.get(this.UPDATE_TRACK_FRAME_CONFIG, options).pipe(catchError(this.handleError));
  }


  public getEquipmentInspections(equipmentId: number): Observable<Inspection[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_INSPECTIONS, options).pipe(catchError(this.handleError));
  }

  /*public SaveUCInspectionDocuments(params: ImplementInspectionAttachmentsVM) {
    return this._http.post('api/ManageEquipment/SaveUCInspectionDocuments', params).share().map(
      (response: Response) => <string>response.json()).catch(this.handleError);
  }*/

  public SaveUCInspectionDocuments(params: ImplementInspectionAttachmentsVM) {
   
    return this._http.post<boolean>('api/ManageEquipment/SaveUCInspectionDocuments', params).pipe(catchError(this.handleError));
  }

  public GetUCInspectionDocInfo(InspectionId: number): Observable<ImplementInspectionAttachmentsVM> {
    const options = {
      params: new HttpParams().set('InspectionId', InspectionId.toString())
    };
    return this._http.get('api/ManageEquipment/GetUCInspectionDocInfo', options).pipe(catchError(this.handleError));
  }


  public getEquipmentAlltypeInspections(equipmentId: number): Observable<Inspection[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_ALL_TYPE_INSPECTIONS, options).pipe(catchError(this.handleError));
  }

  public getEquipmentInspectionsForHistoryLoadCount(equipmentId: number, loadCount: number): Observable<Inspection[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_INSPECTIONS_LOADMORE, options).pipe(catchError(this.handleError));
  }

  public getEquipmentGeneralInspectionsForHistoryLoadCount(equipmentId: number, loadCount: number): Observable<InspectionHistroyWornInfo[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_GENERAL_INSPECTIONS_LOADMORE, options).pipe(catchError(this.handleError));
  }


  public getEquipmentActionInspectionsForHistoryLoadCount(equipmentId: number, loadCount: number): Observable<InspectionHistroyWornInfo[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_ACTION_INSPECTIONS_LOADMORE, options).pipe(catchError(this.handleError));
  }

  public getEquipmentEOLInspectionsForHistoryLoadCount(equipmentId: number, loadCount: number): Observable<InspectionHistroyWornInfo[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_EOL_INSPECTIONS_LOADMORE, options).pipe(catchError(this.handleError));
  }
  public getEquipmentGeneralInspectionsForHistoryLoadCountRSH(equipmentId: number, loadCount: number): Observable<InspectionHistroyWornInfo[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_RSH_GENERAL_INSPECTIONS_LOADMORE, options).pipe(catchError(this.handleError));
  }
  public getEquipmentThermographyInspectionsForHistoryLoadCount(equipmentId: number, loadCount: number): Observable<InspectionHistroyWornInfo[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_THERMOGRAPHY_INSPECTIONS_LOADMORE, options).pipe(catchError(this.handleError));
  }
  public getEquipmentBothTypeInspectionsForHistoryLoadCount(equipmentId: number, loadCount: number): Observable<InspectionHistroyWornInfo[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_BOTH_TYPE_INSPECTIONS_LOADMORE, options).pipe(catchError(this.handleError));
  }



  public getEquipmentInspectionsHistory(equipmentId: number, loadCount: number): Observable<InspectionWornInfo[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('loadCount', loadCount.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_INSPECTION_HISTORY, options).pipe(catchError(this.handleError));
  }

  public getEquipmentSystems(equipmentId: number,todayDate:string): Observable<SystemDetails[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('todayDate', todayDate.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_SYSTEMS, options).pipe(catchError(this.handleError));
  }
  public getEquipmentSystemsForecast(equipmentId: number): Observable<SystemDetails[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_SYSTEMS_ForeCAst, options).pipe(catchError(this.handleError));
  }

  //TT-1966
  public getEquipmentActionHistory(equipmentId: number): Observable<EquipmentActionHistory[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_ACTION_HISTORY, options).pipe(catchError(this.handleError));
  }

  public getEquipmentActionHistoryToEdit(equipmentId: number, actionId: number, actionSMU: number, actionDate: string): Observable<EquipmentActionHistory[]> {
    const options = {
      params: new HttpParams()
        .set('EquipmentId', equipmentId.toString())
        .set('ActionId', actionId.toString())
        .set('ActionSMU', actionSMU.toString())
        .set('ActionDate', actionDate)
    };
    return this._http.get(this.GET_EQUIPMENT_ACTION_HISTORY_EDIT, options).pipe(catchError(this.handleError));
  }
 
  public updateEquipmentActionHistory(model: any): Observable<ApiResponse> {
    return this._http.post<ApiResponse>(this.UPDATE_EQUIPMENT_ACTION_HISTORY, model).pipe(catchError(this.handleError));
  }

  public rollbackEquipmentAction(model: any): Observable<ApiResponse> {
    return this._http.post<ApiResponse>(this.ROLLBACK_EQUIPMENT_ACTION, model).pipe(catchError(this.handleError));
  }

  public getEquipmentInspectionsForComponentsLEFT(equipmentId: number): Observable<ComponentWearGraph[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_COMPONENT_INSPECTION_LEFT, options).pipe(catchError(this.handleError));
  }
  public getEquipmentInspectionsForComponentsRIGHT(equipmentId: number): Observable<ComponentWearGraph[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_COMPONENT_INSPECTION_RIGHT, options).pipe(catchError(this.handleError));
  }

  public getComponentsInstallCMU(equipmentId: number): Observable<ComponentCMU[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_COMPONENT_CMU, options).pipe(catchError(this.handleError));
  }

  public getEquipmentDetails(equipmentId: number): Observable<EquipmentDetails> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_EQUIPMENT_DETAILS, options).pipe(catchError(this.handleError));
  }

  public verifyAccessToEquipment(equipmentId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.VERIFY_ACCESS, options).pipe(catchError(this.handleError));
  }

  public GetRopeShovelReportStyle(equipmentId: number): Observable<number> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_ROPESHOVEL_STLYLE, options).pipe(catchError(this.handleError));
  }

  public GetUoM(): Observable<string> {
    return this._http.get('Api/WSRE/GetUserUOM').pipe(catchError(this.handleError));
  }

  public getFamilyList() {
    return this._http.get('Api/SetupFamily/getAllFamilyList').pipe(catchError(this.handleError));
  }


  public CalculateWornPercentage(UOM: number, toolId: number, impact: number, equnit_auto: number, reading: number): Observable<HttpResponse<Tuple>> {
    const params = new HttpParams()
      .set('UOM', UOM.toString())
      .set('toolId', toolId.toString())
      .set('impact', impact.toString())
      .set('equnit_auto', equnit_auto.toString())
      .set('reading', reading.toString());
    return this._http.get<Tuple>(this.GET_COMPONENT_WORN_CALULATE, {
      params,
      observe: 'response',
      withCredentials: true
    }).pipe(catchError(this.handleError));
  }

  public GetMainCompartMeasurmentPointDetails(CompartId: number): Observable<RSHMainMPInfo> {
    const options = {
      params: new HttpParams().set('CompartId', CompartId.toString())
    };
    return this._http.get(this.GET_COMPONENT_MAIN_MEASUREMENT, options).pipe(catchError(this.handleError));
  }

  public getUnitOfMeasurement(CompartId: number): Observable<UnitOfMeasurement[]> {
    const options = {
      params: new HttpParams().set('CompartId', CompartId.toString())
    };
    return this._http.get('api/RopeShovelInspection/GetUnitOfMeasurement', options).pipe(catchError(this.handleError));
  }

  public CalculateMainRSHCompartMeasurementWornPercentage(MPId: number, toolId: number, UOM: number, reading: number,): Observable<number> {
    const options = {
      params: new HttpParams().set('MPId', MPId.toString()).set('toolId', toolId.toString()).set('UOM', UOM.toString())
        .set('reading', reading.toString())
    };
    return this._http.get(this.GET_COMPONENT_WORN_CALULATE_MP, options).pipe(catchError(this.handleError));
  }


  public getEquipmentStatus(equipmentId: number): Observable<number> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get('api/ManageEquipment/GetEquipmentStatusForEquipment', options).pipe(catchError(this.handleError));
  }

  public UpdateEquipmentStatus(equipmentId: number, EqStatus: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('EqStatus', EqStatus.toString())
    };
    return this._http.get('api/ManageEquipment/UpdateEquipmentStatusForEquipment', options).pipe(catchError(this.handleError));
  }
  
  public UpdateEquipmentShowHideCR(equipmentId: number, Status:boolean ): Observable<boolean> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString()).set('Status', Status.toString())
    };
    return this._http.get('api/ManageEquipment/UpdateEquipmentShowHideCR', options).pipe(catchError(this.handleError));
  }
  
  public HideInspection(inspectionId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get('api/ManageEquipment/UpdateInspectionStatusToHide', options).pipe(catchError(this.handleError));
  }
  private handleError(err: HttpErrorResponse): Observable<any> {
    // return Observable.throw(error.json().error || 'Server error');
    // return Observable.throw(error || 'Server error');
    console.log('handled error ' + err.status);
    return Observable.throw(err || 'Server error');
  }
  // public UpdateEquipmentDetail(equipmentId: number, equipmentinfo :number ): Observable<boolean> {
  //   const options = {
  //     params: new HttpParams().set('equipmentId', equipmentId.toString()).set('EqStatus', EqStatus.toString())
  //   };
  //   return this._http.get('api/ManageEquipment/UpdateEquipmentStatusForEquipment', options).pipe(catchError(this.handleError));
  // }

  public UpdateEquipmentDetail(model: any) {
    return this._http.post('api/ManageEquipment/UpdateEquipmentDetail',model).pipe(catchError(this.handleError));
  }
  public UpdateBudgetDetail(model: any) {
    return this._http.post('api/ManageEquipment/UpdateBudgetDetail',model).pipe(catchError(this.handleError));
  }
  public UpdateActionWO(model: any) {
    return this._http.post('api/ManageEquipment/UpdateActionWO', model).pipe(catchError(this.handleError));
  }

  public getFamilyRenameSprocketFlag(equipmentId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
  };
    return this._http.get('api/ManageEquipment/GetFamilyRenameSprocketFlag', options).pipe(catchError(this.handleError));
  }
  public GetPartMakeModel(equipmentId:number):Observable<PatchTuple>
  {
  const options ={
    params:new HttpParams().set('equipmentId',equipmentId.toString())
  };
  return this._http.get(this.GET_PART_MAKE_MODEL,options).pipe(catchError(this.handleError));
  }

  public changeSystemComponent(comp: ComponentChangeViewModel): Observable<boolean> {
    return this._http.post(this.CHANGE_EQUIPMENT_SYSTEM_COMPONENT, comp).pipe(catchError(this.handleError));
  }
  public addShoeInformation(action: ShoeInformationAdd): Observable<number> {
   
    return this._http.post<number>('api/ManageEquipment/SaveShoeInformation', action).pipe(catchError(this.handleError));
  }

  public updateTrackForcastData(updateModel: UpdateForecastDates): Observable<number> {
    return this._http.post(this.UPDATE_ForecastDate, updateModel).pipe(catchError(this.handleError));
  }

  public getAllEquipmentStatus(): Observable<EquipmentStatusViewModel> {
    return this._http.get(this.GET_EQUIPPMENT_STATUS).pipe(catchError(this.handleError));
  }

  public getCompartList(compartTypeId: number, equipmentId:number, selectedCompartId:any): Observable<CompartDtoVM> {
    const options ={
    params:new HttpParams().set('compartTypeId', compartTypeId).set('equipmentId', equipmentId).set('compartId', selectedCompartId)
  }
    return this._http.get<CompartDtoVM>(this.GET_COMPART_LIST, options).pipe(catchError(this.handleError));
  }

  public GetComponentPosition(equipmentId: number, compartTypeId: number): Observable<ComponentPositionVM> {
    const options ={
    params:new HttpParams().set('equipmentId', equipmentId).set('compartTypeId', compartTypeId)
  }
    return this._http.get<ComponentPositionVM>(this.GET_COMPONENT_POSITION, options).pipe(catchError(this.handleError));
  }

  public GetChildComponent(compartId: number, equipmentId: number): Observable<ChildComponentVM> {
    const options ={
    params:new HttpParams().set('compartId', compartId).set('equipmentId', equipmentId)
  }
    return this._http.get<ChildComponentVM>(this.GET_CHILD_COMPONENT, options).pipe(catchError(this.handleError));
  }

  addNewComponent(request: AddComponentRequest): Observable<ApiResponse> {
    return this._http.post<ApiResponse>(this.ADD_NEW_COMPONENT, request).pipe(catchError(this.handleError));
  }

  public GetEquipmentComponent(compartId: number, equipmentId: number): Observable<EquipmentCompartDtoVM> {
    const options ={
    params:new HttpParams().set('compartId', compartId).set('equipmentId', equipmentId)
  }
    return this._http.get<EquipmentCompartDtoVM>(this.GET_EQUIPMENT_COMPONENT, options).pipe(catchError(this.handleError));
  }

  calcBushTurned(request: BushTurnedCalcParams): Observable<number> {
   return this._http.post<number>(this.UPDATE_BUSH_TURNED, request).pipe(catchError(this.handleError));
  }
  public GetManualInspection(equipmentId: number) {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get(this.GET_MANUAL_INSPECTION_REPORT, options).pipe(catchError(this.handleError));
  }

   public getEquipmentBySystems(systemId: number,todayDate:string, includeChildren: boolean): Observable<SystemDetails> {
    const options = {
      params: new HttpParams().set('systemId', systemId.toString()).set('todayDate', todayDate.toString()).set('IncludeChildren', includeChildren.toString())
    };
    return this._http.get(this.GET_EQUIPMENTBy_SYSTEMS, options).pipe(catchError(this.handleError));
  }
    public getSystemIds(equipmentId: number): Observable<number[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<any>('api/ManageEquipment/getsystemids', options).pipe(catchError(this.handleError));
  }

  public GetEquipmentCompartmentTypes(equipmentId: number): Observable<EquipmentCompartmentTypeModel[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<EquipmentCompartmentTypeModel[]>('api/ManageEquipment/GetEquipmentCompartmentTypes', options).pipe(catchError(this.handleError));
  }

   public SavePercentWornPreference(action: any): Observable<number> {
   
    return this._http.post<number>('api/ManageEquipment/SavePercentWornPreference', action).pipe(catchError(this.handleError));
  }

  smuValidationCheck(request: SMUValidationCheckRequest): Observable<ApiResponse> {
    return this._http.post<ApiResponse>(this.GET_EQUIPMENT_SMU_VALIDATION, request).pipe(catchError(this.handleError));
  }

  //  public GetPercentWornPreference(equipmentId: number): Observable<EquipmentPercentWornPreferenceDto> {
  //   const options = {
  //     params: new HttpParams().set('equipmentId', equipmentId.toString())
  //   };
  //   return this._http.get<EquipmentPercentWornPreferenceDto>('api/ManageEquipment/GetPercentWornPreference', options).pipe(catchError(this.handleError));
  // }

  public addNewComponentValidation(request: AddComValidationRequest): Observable<AddNewCompValidationResponseVM> {
    return this._http.post<AddNewCompValidationResponseVM>(this.GET_COMP_VALIDATION, request).pipe(catchError(this.handleError));
  }
}
